var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleFaceboookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1093 16.3953C31.1093 7.83276 24.1718 0.895264 15.6093 0.895264C7.04675 0.895264 0.109253 7.83276 0.109253 16.3953C0.109253 24.1453 5.73425 30.5828 13.1718 31.7078V20.8953H9.23425V16.3953H13.1718V13.0203C13.1718 9.14526 15.4843 6.95776 18.9843 6.95776C20.7343 6.95776 22.4843 7.27026 22.4843 7.27026V11.0828H20.5468C18.6093 11.0828 17.9843 12.2703 17.9843 13.5203V16.3953H22.2968L21.6093 20.8953H17.9843V31.7078C25.4218 30.5828 31.1093 24.1453 31.1093 16.3953Z",
    fill: "#804B80"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleFaceboookIcon);
export default __webpack_public_path__ + "static/media/purple-faceboook-icon.bf4b799b1002f551af8cd5c7fae24102.svg";
export { ForwardRef as ReactComponent };